import { ARCHIVED_ASSET_STATUS } from "@constants";

/**
 * 아카이브와 연관된 상태인지 확인하는 함수
 * @param {string} archiveStatus - 확인할 아카이브 상태
 * @returns {boolean} - 아카이브와 연관된 상태면 true, 아니면 false
 */
const isArchiveRelatedStatus = (archiveStatus) => {
    const blockedArchiveStatuses = [
        ARCHIVED_ASSET_STATUS.REQUEST_ARCHIVE,
        ARCHIVED_ASSET_STATUS.ARCHIVING,
        ARCHIVED_ASSET_STATUS.ARCHIVED,
        ARCHIVED_ASSET_STATUS.REQUEST_RESTORE,
        ARCHIVED_ASSET_STATUS.RESTORING,
        ARCHIVED_ASSET_STATUS.RESTORE_ERROR,
    ];

    return blockedArchiveStatuses.includes(archiveStatus);
};

const canNavigateToArchiveDetail = (archiveStatus) => {
    const navigatableStatuses = [
        ARCHIVED_ASSET_STATUS.ARCHIVED,
        ARCHIVED_ASSET_STATUS.RESTORING,
        ARCHIVED_ASSET_STATUS.RESTORE_ERROR,
    ];
    return navigatableStatuses.includes(archiveStatus);
};

export { isArchiveRelatedStatus, canNavigateToArchiveDetail };
